import React, { useState } from 'react';
import Upload from './Upload';
import ListaDinamica from './ListaDinamica';
import { PAPEIS_ENVOLVIDO } from '../constants/opcoes';

const ETAPAS = [
  'Tipo de denúncia',
  'O que aconteceu',
  'Onde aconteceu',
  'Pessoas envolvidas',
  'Contexto e riscos',
  'Evidências',
];

const CAMPOS_ENVOLVIDO = [
  { chave: 'nome', rotulo: 'Nome (se conhecido)', placeholder: 'Nome ou como é conhecido(a)' },
  { chave: 'funcao', rotulo: 'Função', placeholder: 'Ex: Gerente, Vendedor(a)' },
  { chave: 'area', rotulo: 'Área', placeholder: 'Ex: Comercial, Financeiro' },
  { chave: 'papel', rotulo: 'Papel no caso', tipo: 'select', opcoes: PAPEIS_ENVOLVIDO },
];

const CAMPOS_TESTEMUNHA = [
  { chave: 'nome', rotulo: 'Nome', placeholder: 'Nome ou como é conhecido(a)' },
  { chave: 'observacao', rotulo: 'Observação', placeholder: 'Ex: estava presente no momento do fato' },
];

function FormDenuncia({ categorias, unidades, onSubmit, loading, anonima, unidadePreSelecionada }) {
  const [form, setForm] = useState({
    categoria_id: '',
    descricao: '',
    data_fato: '',
    situacao_continua: '',
    // Vem do QR de uma unidade (spec 2.6); o denunciante ainda pode trocar no select.
    unidade_id: unidadePreSelecionada || '',
    envolvidos: [],
    testemunhas: [],
    ja_comunicou: '',
    comunicou_para: '',
    risco_imediato: false,
    risco_destruicao_provas: false,
    risco_retaliacao: false,
    info_adicional: '',
    evidencias: [],
  });
  const [step, setStep] = useState(1);

  const set = (chave, valor) => setForm((f) => ({ ...f, [chave]: valor }));

  const handleFilesSelected = (files) => set('evidencias', files);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.categoria_id || form.descricao.trim().length < 20 || !form.unidade_id) {
      alert('Preencha todos os campos obrigatórios');
      return;
    }
    onSubmit({
      ...form,
      data_fato: form.data_fato ? new Date(form.data_fato).toISOString() : undefined,
      situacao_continua: form.situacao_continua === '' ? undefined : form.situacao_continua === 'sim',
      ja_comunicou: form.ja_comunicou === '' ? undefined : form.ja_comunicou === 'sim',
      envolvidos: form.envolvidos.filter((e2) => (e2.nome || e2.funcao || e2.area)),
      testemunhas: form.testemunhas.filter((t) => t.nome),
    });
  };

  const nextStep = () => {
    if (step === 1 && !form.categoria_id) { alert('Selecione uma categoria'); return; }
    if (step === 2 && form.descricao.trim().length < 20) { alert('Descreva o fato com pelo menos 20 caracteres'); return; }
    if (step === 3 && !form.unidade_id) { alert('Selecione a unidade'); return; }
    setStep(step + 1);
  };

  const prevStep = () => { if (step > 1) setStep(step - 1); };

  return (
    <form onSubmit={handleSubmit} className="form">
      {step === 1 && (
        <div className="form-step">
          <label htmlFor="categoria">Qual é o tipo de denúncia?</label>
          <select id="categoria" value={form.categoria_id} onChange={(e) => set('categoria_id', e.target.value)} required>
            <option value="">-- Selecione --</option>
            {categorias.map((c) => <option key={c.id} value={c.id}>{c.nome}</option>)}
          </select>
          <div className="step-buttons">
            <button type="button" className="btn btn-primary" onClick={nextStep}>Próximo</button>
          </div>
        </div>
      )}

      {step === 2 && (
        <div className="form-step">
          <label htmlFor="descricao">Descreva o fato em detalhes</label>
          <textarea
            id="descricao"
            placeholder="Inclua datas, horários, nomes de pessoas envolvidas e qualquer informação relevante"
            value={form.descricao}
            onChange={(e) => set('descricao', e.target.value)}
            rows={6}
            minLength={20}
            required
          />
          <p className="help-text">
            {form.descricao.trim().length < 20
              ? `Faltam pelo menos ${20 - form.descricao.trim().length} caracteres`
              : `${form.descricao.length} caracteres`}
          </p>

          <label htmlFor="data_fato">Quando aconteceu? (opcional)</label>
          <input id="data_fato" type="date" value={form.data_fato} onChange={(e) => set('data_fato', e.target.value)} />

          <label>A situação ainda está ocorrendo?</label>
          <div className="radio-group">
            {[['sim', 'Sim'], ['nao', 'Não'], ['', 'Não sei']].map(([v, label]) => (
              <label key={label}>
                <input
                  type="radio"
                  name="situacao_continua"
                  checked={form.situacao_continua === v}
                  onChange={() => set('situacao_continua', v)}
                />
                {label}
              </label>
            ))}
          </div>

          <div className="step-buttons">
            <button type="button" className="btn btn-secondary" onClick={prevStep}>Voltar</button>
            <button type="button" className="btn btn-primary" onClick={nextStep}>Próximo</button>
          </div>
        </div>
      )}

      {step === 3 && (
        <div className="form-step">
          <label htmlFor="unidade">Em qual unidade ocorreu o fato?</label>
          <select id="unidade" value={form.unidade_id} onChange={(e) => set('unidade_id', e.target.value)} required>
            <option value="">-- Selecione --</option>
            {unidades.map((u) => <option key={u.id} value={u.id}>{u.nome}</option>)}
          </select>
          <div className="step-buttons">
            <button type="button" className="btn btn-secondary" onClick={prevStep}>Voltar</button>
            <button type="button" className="btn btn-primary" onClick={nextStep}>Próximo</button>
          </div>
        </div>
      )}

      {step === 4 && (
        <div className="form-step">
          <label>Pessoas envolvidas (opcional)</label>
          <ListaDinamica
            itens={form.envolvidos}
            onChange={(v) => set('envolvidos', v)}
            campos={CAMPOS_ENVOLVIDO}
            botaoTexto="Adicionar envolvido"
            vazio="Nenhum envolvido adicionado."
          />

          <label style={{ marginTop: 'var(--space-2)' }}>Testemunhas (opcional)</label>
          <ListaDinamica
            itens={form.testemunhas}
            onChange={(v) => set('testemunhas', v)}
            campos={CAMPOS_TESTEMUNHA}
            botaoTexto="Adicionar testemunha"
            vazio="Nenhuma testemunha adicionada."
          />

          <div className="step-buttons">
            <button type="button" className="btn btn-secondary" onClick={prevStep}>Voltar</button>
            <button type="button" className="btn btn-primary" onClick={nextStep}>Próximo</button>
          </div>
        </div>
      )}

      {step === 5 && (
        <div className="form-step">
          <label>Já comunicou esse fato anteriormente?</label>
          <div className="radio-group">
            {[['sim', 'Sim'], ['nao', 'Não'], ['', 'Não sei']].map(([v, label]) => (
              <label key={label}>
                <input type="radio" name="ja_comunicou" checked={form.ja_comunicou === v} onChange={() => set('ja_comunicou', v)} />
                {label}
              </label>
            ))}
          </div>
          {form.ja_comunicou === 'sim' && (
            <input
              type="text"
              placeholder="Para quem você comunicou?"
              value={form.comunicou_para}
              onChange={(e) => set('comunicou_para', e.target.value)}
            />
          )}

          <label className="checkbox-label">
            <input type="checkbox" checked={form.risco_imediato} onChange={(e) => set('risco_imediato', e.target.checked)} />
            <span>Existe risco imediato para alguma pessoa?</span>
          </label>
          <label className="checkbox-label">
            <input type="checkbox" checked={form.risco_destruicao_provas} onChange={(e) => set('risco_destruicao_provas', e.target.checked)} />
            <span>Há risco de destruição de provas?</span>
          </label>
          <label className="checkbox-label">
            <input type="checkbox" checked={form.risco_retaliacao} onChange={(e) => set('risco_retaliacao', e.target.checked)} />
            <span>Você teme sofrer retaliação?</span>
          </label>

          <label htmlFor="info_adicional">Há informação adicional relevante? (opcional)</label>
          <textarea
            id="info_adicional"
            rows={3}
            value={form.info_adicional}
            onChange={(e) => set('info_adicional', e.target.value)}
          />

          <div className="step-buttons">
            <button type="button" className="btn btn-secondary" onClick={prevStep}>Voltar</button>
            <button type="button" className="btn btn-primary" onClick={nextStep}>Próximo</button>
          </div>
        </div>
      )}

      {step === 6 && (
        <div className="form-step">
          <label>Adicionar evidências (opcional)</label>
          <Upload onFilesSelected={handleFilesSelected} />
          <p className="help-text">Formatos aceitos: JPG, PNG, PDF, MP4, DOCX, XLSX</p>
          <div className="step-buttons">
            <button type="button" className="btn btn-secondary" onClick={prevStep}>Voltar</button>
            <button type="submit" className="btn btn-submit" disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar denúncia'}
            </button>
          </div>
        </div>
      )}

      <div className="step-progress">
        <div className="step-progress__label">
          <span>Etapa {step} de {ETAPAS.length}</span>
          <strong>{ETAPAS[step - 1]}</strong>
        </div>
        <div className="step-progress__track">
          <div className="step-progress__fill" style={{ width: `${(step / ETAPAS.length) * 100}%` }} />
        </div>
      </div>
    </form>
  );
}

export default FormDenuncia;
